import React from "react";

const UserListContext = React.createContext();

export default UserListContext;